<template>
  <v-container>
   <!-- <v-textarea v-model="content" height="600"></v-textarea> -->

   <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Question</th>
                  <th class="text-left">Answer</th>
                  <!-- <th class="text-left">Name</th> -->
                  <!-- <th class="text-left">Start time</th> -->
                  <!-- <th class="text-left">Duration (minutes)</th> -->
                  <!-- <th class="text-left">Freezed?</th>  -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="content in contents" :key="content.id">
                    <td>{{ JSON.stringify(content.question) }}</td>
                  <td>{{ JSON.stringify(content.answer) }}</td>
                </tr>
              </tbody>
              <!-- <tfoot>
            <td colspan="2">
              
            </td>
              </tfoot>-->
            </template>
          </v-simple-table>
  </v-container>
</template>

<script>
export default {
  name: "ShowAnswer",
  props: ["eid", "sid"],

//   methods: {
    // async newQuestion() {
    //   var response = await fetch(
    //     process.env.VUE_APP_API_BASE_URL + "/questionOrder/showAnswer/" + eid + "/" + sid,
    //     {
    //       method: "GET",
    //       credentials: "same-origin",
    //     //   headers: {
    //     //     "Content-Type": "application/json"
    //     //     // 'Content-Type': 'application/x-www-form-urlencoded',
    //     //   },
    //     //   body: JSON.stringify({ section: this.id, type: this.type })
    //     }
    //   );

    //   if (response.ok) {
    //     var data = await response.json();
    //     // console.log(data);
    //     alert(data);

    //     // this.$router.push({ path: `/edit/${data.id}` }); // -> /user/123
    //   } else {
    //     alert(response.status + ": " + response.statusText);
    //   }

    //   // var html = await response.text();
    //   // alert(html);
    // }
//   },

  data: () => ({
    questions: [],
    type: "",
    contents: []
  }),

  async mounted() {
     var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/questionOrder/showAnswer/" + this.eid + "/" + this.sid,
        {
          method: "GET",
          credentials: "include",
        //   headers: {
        //     "Content-Type": "application/json"
        //     // 'Content-Type': 'application/x-www-form-urlencoded',
        //   },
        //   body: JSON.stringify({ section: this.id, type: this.type })
        }
      );

      if (response.ok) {
        var data = await response.json();
        // console.log(data);
        // alert(data);

        this.contents = data;

        // this.$router.push({ path: `/edit/${data.id}` }); // -> /user/123
      } else {
        alert(response.status + ": " + response.statusText);
      }
  }
};
</script>